export default "__VITE_ASSET__DTlBoYHy__"